const MARK = { gbp: "£", eur: "€", usd: "$" };
const PAY_IN = { gbp: "pounds", eur: "euros", usd: "US dollars" };

export const OFFER_PACK_SIZES = [100, 500, 1000];

/** Contracted public list. Must match Backend/Optivise/Services/PublicSkuCatalogue.cs. */
export const PUBLIC_PACK_MAJOR = {
  usd: { 100: 140, 500: 600, 1000: 1000 },
  eur: { 100: 125, 500: 550, 1000: 900 },
  gbp: { 100: 105, 500: 450, 1000: 750 },
};

export const PUBLIC_PACK_CHECKOUT_IDS = {
  100: "Credits 100",
  500: "Credits 500",
  1000: "Credits 1,000",
};

export function skuOfferFromProfile(tenantProfile) {
  const currency = tenantProfile?.skuOfferCurrency;
  const minor = tenantProfile?.skuOfferMinorPerSku;
  if (!currency || minor == null || minor <= 0) return null;
  return formatSkuOffer(currency, minor);
}

export function publicPackInCurrency(currency, skuCount) {
  const c = String(currency || "").toLowerCase();
  const major = PUBLIC_PACK_MAJOR[c]?.[skuCount];
  if (major == null) return null;
  const mark = MARK[c] || c;
  return {
    currency: c,
    skuCount,
    major,
    mark,
    perSku: `${mark}${(major / skuCount).toFixed(2)}`,
  };
}

export function publicVolumeLadder(currency) {
  const packs = OFFER_PACK_SIZES.map((n) => publicPackInCurrency(currency, n));
  if (packs.some((p) => !p)) return null;
  return `${packs[0].perSku}, ${packs[1].perSku}, then ${packs[2].perSku}`;
}

export function formatSkuOffer(currency, minor) {
  const c = String(currency).toLowerCase();
  const mark = MARK[c] || c;
  const unitCopy =
    c === "gbp" && minor < 100
      ? `${minor}p per SKU`
      : `${mark}${(minor / 100).toFixed(2)} per SKU`;
  return {
    currency: c,
    minor,
    mark,
    unitCopy,
    payIn: PAY_IN[c] || c,
    packPrice: (skuCount) => (skuCount * minor) / 100,
    publicPack: (skuCount) => publicPackInCurrency(c, skuCount),
    volumeLadder: publicVolumeLadder(c),
  };
}
